<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-row>
          <el-col :lg="5" :xl="5">
            <el-form-item label="外协单号" class="EL-Form-Item">
              <el-input v-model="outsoureListSerach.operaCode" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="状态" class="EL-Form-Item">
              <el-select v-model="outsoureListSerach.spStatus" placeholder="请选择" clearable="clearable">
                <el-option label="发货中" value="EXECUTE" />
                <el-option label="完成" value="COMPLETE" />
                <el-option label="取消" value="CANCEL" />
                <el-option label="关闭" value="CLOSE" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="开始日期" class="EL-Form-Item">
              <el-date-picker v-model="outsoureListSerach.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="5" :xl="5">
            <el-form-item label="结束日期" class="EL-Form-Item">
              <el-date-picker v-model="outsoureListSerach.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="4" :xl="4">
            <el-form-item class="btn-edit-delete EL-Form-Item">
              <el-button class="btn-t-edit" @click="getStockPickDetailList('')">
                查询
              </el-button>
              <el-button class="btn-t-delete" @click="mainReset()">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </box>
    <box fill>
      <plabel text="外协发货列表">
        <el-button v-authority="'BACK_MENU6_M2_B1'" class="btn-t-edit" @click="getPrintList()">单据打印</el-button>
        <el-button @click="pickStockReturnList()" type="danger" class="btn-t-edit" v-authority="'BACK_MENU6_M2_B5'" >确认发货</el-button>
        <el-button v-authority="'BACK_MENU6_M2_B2'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
      </plabel>
      <h-table :headerCellStyle="outsourceDetail.headerCellStyle" style="flex: 1" pagination :data="outsourceDetail.data" :total.sync="outsourceDetail.total" @selectionChange="checkboxOutsourceDet">
        <el-table-column type="selection" align="center">
        </el-table-column>
        <el-table-column label="外协单号" prop="operaCode" align="center">
        </el-table-column>
        <!-- <el-table-column label="拣货单号" prop="spCode" align="center">
        </el-table-column> -->
        <el-table-column label="物料编号" prop="matCode" align="center">
        </el-table-column>
        <el-table-column label="物料描述" prop="matName" align="center">
        </el-table-column>
        <el-table-column label="物料数量" prop="matQuan" align="center">
        </el-table-column>
        <el-table-column label="实际发货数量" align="center" prop="matQuan">
        </el-table-column>
        <el-table-column label="发货扫描" align="center">
          <template slot-scope="scope">
            {{ scope.row.scanFlag ? "已扫描" : "未扫描" }}
          </template>
        </el-table-column>
        <!--
          <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                  <div v-if="operaType=='10'">
                      <span v-if="scope.row.distrType == '10'">待配送</span>
                      <span v-if="scope.row.distrType == '20'">配送中</span>
                      <span v-if="scope.row.distrType == '30'">配送完成</span>
                      <span v-if="scope.row.distrType == '40'">关闭</span>
                  </div>
                  <div v-else>
                      <span v-if="scope.row.distrType == '40'">关闭</span>
                  </div>
              </template>
          </el-table-column>-->
        <el-table-column label="推荐库位" prop="laCodeAdvise" align="center">
        </el-table-column>
        <el-table-column label="实际库位" prop="laCodeReal" align="center">
        </el-table-column>
        <el-table-column label="规值" prop="matSpecs" align="center">
        </el-table-column>
        <el-table-column label="箱号" prop="boxBarcode" align="center">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center">
        </el-table-column>
        <el-table-column label="发货操作员" prop="person" align="center">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button class="btn-t-edit" type="primary" @click="laCodeReset(scope.row)" :disabled='scope.row.scanFlag?true:false'>重新推荐库位</el-button> -->
            <el-button class="btn-t-edit" type="primary" @click="dialogOpenPD(scope.row)" :disabled="scope.row.scanFlag || operaType == '30' || scope.row.distrType == '40'?true:false" v-authority="'BACK_MENU6_M2_B4'" >关闭</el-button>
          </template>
        </el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="closeDetailDialog" type="info" class="btn-t-info">取 消</el-button>
        <el-button @click="pickStockReturnList()" type="danger" class="btn-t-edit" :disabled='buttonShow' v-authority="'BACK_MENU6_M2_B5'" >确认发货</el-button>
      </div>
    </box>


    <el-dialog title="打印" :visible.sync="printShow" width="1500px" :close-on-click-modal="false">
      <v-print :doPrint.sync="print">
        <div id="demo" class="demo">
          <div>
            <div style="margin-left: -1200px; margin-top: 50px">
              {{ timeDate }}
            </div>
            <div style="margin-right: -1200px; margin-top: 50px">
              <el-button size="small" type="primary" @click="clearPrintData">
                清空数据
              </el-button>
            </div>
            <div style="
                                font-size: 30px;
                                font-weight: 600;
                                margin-top: 20px;
                                text-align: center;
                                ">
              {{ operaType }}发货单
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <!-- <span>工序：</span> -->
              <span>通道：{{whCodes}}</span>
              <span>班次：</span>
              <span>申请人：{{persons}}</span>
              <span>日期：{{ timeDate }}</span>
              <span>外协单号：{{operaCode}}</span>
              <span>发货（库房）：</span>
              <span>发货（通道）：</span>
            </div>
            <div class="table">
              <table width="100%" border="1" cellpadding="0" cellspacing="0">
                <tr>
                  <th></th>
                  <th colspan="3">通道下单</th>
                  <th colspan="4">通道接单</th>
                  <!-- <th colspan="2">通道接料</th> -->
                </tr>
                <tr class="td">
                  <td>序号</td>
                  <td>型号</td>
                  <td>规值</td>
                  <td>数量</td>
                  <td>实发库位</td>
                  <td>箱号</td>
                  <!-- <td>数量</td> -->
                  <td>实发数量</td>
                  <td>备注</td>
                </tr>
                <tr v-for="(item, index) in printList" :key="index">
                  <td>{{index + 1}}</td>
                  <td>{{item.matCode}}-{{item.matName}}</td>
                  <td>{{ item.matSpecs }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td>{{ item.laCodeReal }}</td>
                  <td>{{ item.boxBarcode }}</td>
                  <td>{{ item.matQuan }}</td>
                  <td></td>
                  <!-- <td>{{ item.matQuan }}</td> -->
                </tr>
              </table>
            </div>
            <div class="div" style="margin-top: 10px; font-size: 20px">
              <span>总数量：{{ summarySumNumber }}</span>
              <span>箱数：{{ boxNumber }}</span>
            </div>
          </div>
        </div>
      </v-print>

      <div style="margin-top: 50px;height:80px">
        <el-button class="btn-t-edit" @click="(printShow = false)">取消</el-button>
        <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
      </div>
    </el-dialog>

    <el-dialog title="关闭发货详情" :visible.sync="closePickDShow" width="700px" :style="$popups.popups(0.8,0.8)" :close-on-click-modal="false" :show-close="false">
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-form-item label="发货单号" class="EL-Form-Item">
          <el-input v-model="closeObj.spCode" readonly />
        </el-form-item>
        <el-form-item label="物料编号" class="EL-Form-Item">
          <el-input v-model="closeObj.matCode" readonly />
        </el-form-item>
        <el-form-item label="实际库位" class="EL-Form-Item">
          <el-input v-model="closeObj.laCodeReal" readonly />
        </el-form-item>
        <el-form-item label="箱号" class="EL-Form-Item">
          <el-input v-model="closeObj.boxBarcode" readonly />
        </el-form-item>
        <el-form-item label="备注" class="EL-Form-Item">
          <el-input v-model="closeObj.remarks" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogClosePD()" type="info" class="btn-t-info">取 消</el-button>
        <el-button @click="closePickDetail()" type="danger" class="btn-t-edit">确认关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import printJS from "print-js";
import vPrint from 'syl-vue-printer'
import htmlToPdf from "@/libs/htmlToPdf";
export default {
  name: "OutsourcePick",
  components: {
    vPrint
  },
  data() {
    return {
      //导出动态加载
      downloadLoading: false,
      //拣配列表窗口
      outsourceListPickShow: false,
      //外协集合
      outsourceList:{
        pageNum: 1,
        pageSize: 50,
        total: 0,
        data: [],
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      //外协查询条件
      outsoureListSerach:{
        fcCode: localStorage.getItem("fcCode") || "",
        operaCode: "",
        spStatus:"EXECUTE",
        operaType:"60",
        date: [],
      },
      operaCode:"",
      detailsData:{
        nowPage:1,
        pageSize:50,
        total: 0,
        data: [],
      },
      //外协拣配窗口
      outsourceDetailsDialogShow:false,
      //外协明细数据
      outsourceDetail:{
        pageNum: 1,
        pageSize: 50,
        total: 0,
        data: [],
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      //判断拣货单是查看还是拣配
      buttonShow: false,
      checkList:[],
      checkDetail:[],
      //单据打印文字
      operaType:"",
      //单据打印的数据
      spIdList:[],
      //单据打印存放数据
      printList:[],
      //单据打印窗口
      printShow:false,
      //单据打印时间
      timeDate: new Date(),
      //存放通道签字
      whCodes:"",
      printObj: {
        id: "demo",
        popTitle: "",
      },
      print: false,
      //汇总对象
      SummaryData:{},
      //总数量
      sumNumber:0,
      //汇总总数量
      summarySumNumber: 0,
      //总箱数
      boxNumber:0,
      persons: localStorage.getItem("userName"),

      //关闭外协单窗口
      closePickDShow:false,
      spId: "",
      closeObj: {},
    };
  },
  watch: {
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout)
        this.isSetTimeout = setTimeout(() => {
          this.outsourceDetail.pageNum = 1;
          this.getStockPickPage(newVal);
        }, 1000)
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this
      return {
        disabledDate(time) {
          if (_this.outsoureListSerach.date[0]) {
            return time.getTime() < new Date(_this.outsoureListSerach.date[0]);
          }
        }
      }
    },
    pickerOptions0() {
      let _this = this
      return {
        disabledDate(time) {
          if (_this.outsoureListSerach.date[1]) {
            return time.getTime() > new Date(_this.outsoureListSerach.date[1]);
          }
        }
      }
    },
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy)
      window.lazy = window.setTimeout(() => {
        this.outsourceDetail.pageNum = 1;
        this.getOutsourceList()
      }, 1000)
    },

    handleDown() {
      // console.log(document.querySelector("#demo"));
      htmlToPdf.downloadPDF(document.querySelector("#demo"), "X-R控制图");
    },

    // 确认收货完成
    confirmReceiptCompleted(){
      this.$http
          .request({
            url: "/api/outsource/confirmReceiptCompleted",
            method: "GET",
            params: {
              spId: spId || null,
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.outsourceDetail.data = resp.data.list || [];
              this.outsourceDetail.total = resp.data.total;
            }
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
    },

    /* 获取外协拣配数据 */
    getOutsourceListPickShow(){
      this.getOutsourceList();
      this.outsourceListPickShow = true;
    },

    /**
     * 多选
     */
    checkboxMain(val) {
      this.checkList = val;
    },
    checkboxOutsourceDet(val) {
      this.checkDetail = val;
    },
    //禁选
    checkboxDeatilSelect(row, rowIndex) {
      if (row.scanFlag || row.distrType == '40') {
        // return false; // 禁用
      } else {
        return true; // 不禁用
      }
    },

    /**
     * 详情
     */
    detailsDialog(row) {
      if (row.spStatus == 'EXECUTE') {
        this.buttonShow = false;
      } else {
        this.buttonShow = true;
      }
      this.operaType = row.operaType;
      this.outsourceDetail.data = [];
      this.outsourceDetailsDialogShow = true;
      this.getStockPickDetailList(row.spId);
      this.spId = row.spId;
    },

    /**
     * 获取当前时间
     * 格式YYYY-MM-DD
     */
    getTime() {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timeDate = year + seperator1 + month + seperator1 + strDate;
    },

    //清空打印数据
    clearPrintData(){
      this.printList = [];
      this.summarySumNumber = 0;
      this.sumNumber = 0;
      this.boxNumber = 0;
      this.whCodes = "";
      this.spIdList = [];
    },

    /**
     * 查询拣货单详情记录
     */
    getStockPickDetailList(spId) {
      this.$http
          .request({
            url: "/api/order/getStockPickDetailList",
            method: "GET",
            params: {
              pageNum: this.detailsData.nowPage,
              pageSize: this.detailsData.pageSize,
              spId: spId || null,
              operaType:"60",
              operaCode:this.outsoureListSerach.operaCode,
              spStatus:this.outsoureListSerach.spStatus,
              beginTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[0] : null,
              endTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[1] : null,
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.outsourceDetail.data = resp.data.list || [];
              this.outsourceDetail.total = resp.data.total;
            }
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
    },

    getPrintList() {
      this.checkList = this.checkDetail;
      if(this.checkList.length == 0){
        this.printShow = true;
      }else{
        var code = 0;
        var whCode = this.checkList[0].whCode;
        this.checkList.forEach((item) => {
          if(this.spIdList.indexOf(item.spId) < 0){
            this.spIdList.push(item.spId);
          }
          this.operaCode = item.operaCode;

        })

        var spId = this.spIdList.join(",")

        if(this.checkList[0].operaType == "10"){
          this.operaType = "叫料"
        }else if(this.checkList[0].operaType == "20"){
          this.operaType = "部门领用"
        }else if(this.checkList[0].operaType == "30"){
          this.operaType = "采购退货"
        }else if(this.checkList[0].operaType == "50"){
          this.operaType = "冻结"
        }else if(this.checkList[0].operaType == "60"){
          this.operaType = "外协"
        }
        this.whCodes = whCode;
        this.printShow = true;
        this.$http
            .request({
              url: "/api/order/getStockPickDetailList",
              method: "GET",
              params: {
                pageNum: 0,
                pageSize: 0,
                spId: spId || null,
              },
            })
            .then((resp) => {
              if (resp.status == 100) {
                if (resp.data.list != null) {
                  this.printsList = resp.data.list;
                  var matCode = resp.data.list[0].matCode || "";
                  this.printList = [];
                  this.summarySumNumber = 0;
                  this.sumNumber = 0;
                  this.printsList.forEach((item,index)=>{
                    if(matCode == item.matCode){
                      this.sumNumber += item.matQuan;
                      this.printList.push(item);
                    }else{
                      this.printList.push({matQuan:this.sumNumber});
                      this.printList.push(item)
                      matCode = item.matCode;
                      this.summarySumNumber += this.sumNumber;
                      this.sumNumber = item.matQuan;
                    }
                  })
                  this.printList.push({matQuan:this.sumNumber})
                  this.summarySumNumber += this.sumNumber;
                  this.boxNumber = resp.data.total;
                  this.printShow = true;
                } else {
                  this.$message({
                    message: "未找到拣货详情打印记录！",
                    type: "warning",
                  });
                }
              }
            })
            .catch((error) => {
              this.$message({
                message: "操作失败",
                type: "warning",
              });
            });
      }

    },

    // 关闭外协详情
    closeDetailDialog(){
      this.outsourceDetailsDialogShow = false;
      this.getOutsourceList();
    },


    //关闭拣货详情
    dialogOpenPD(row) {
      this.closeObj = row;
      this.closePickDShow = true;
    },
    dialogClosePD() {
      this.closeObj = {};
      this.closePickDShow = false;
      this.getStockPickDetailList(this.spId);
    },
    closePickDetail() {
      this.$confirm("确认关闭该箱物料的发货详情?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.request({
          url: "/api/stockPickDetail/closePickDetail",
          method: "POST",
          showLoading: true,
          params: {
            spdId: this.closeObj.spdId,
            person: localStorage.getItem("user") || "",
            personNumber: localStorage.getItem("empNumber") || null,
            remarks: this.closeObj.remarks,
          },
        }).then((resp) => {
          if (resp.status == 100) {
            this.$message({
              type: "success",
              message: "关闭成功",
            });
          } else {
            this.$message({
              type: "error",
              message: resp.message,
            });
          }
          this.dialogClosePD();
        }).catch((error) => {
          this.$message({
            type: "error",
            message: "关闭失败",
          });
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消关闭",
        });
      });
    },

    /**
     * 拣货记录-确认拣货
     */
    pickStockReturnList() {
      if (this.checkDetail.length == 0) {
        this.$message({
          message: "请先勾选记录！",
          type: "warning",
        });
        return;
      }
      this.$confirm("是否确认发货?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$http
                .request({
                  url: "/api/order/pickStockReturnList/" +
                      localStorage.getItem("user"),
                  method: "POST",
                  showLoading: true,
                  data: this.checkDetail,
                  params: {
                    personNumber: localStorage.getItem("empNumber") || null,
                  }
                })
                .then((resp) => {
                  if (resp.status == 100) {
                    this.$message({
                      message: "操作成功",
                      type: "success",
                    });
                    this.logRemarks = "order：确认发货成功";
                  } else {
                    this.$message({
                      message: resp.message,
                      type: "error",
                    });
                    this.logRemarks = "order：确认发货失败";
                  }
                  this.logContent = JSON.stringify(this.checkDetail);
                  this.systemLog();
                  //刷新数据
                  this.dialogClose();
                })
                .catch((error) => {
                  this.$message({
                    message: "操作失败",
                    type: "warning",
                  });
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消收货",
            });
          });
    },

    //扫描取消
    dialogClose() {
      this.outsourceDetailsDialogShow = false;
      this.getOutsourceList();
    },

    /**
     * 查询拣货单记录
     */
    getOutsourceList() {
      this.$http
          .request({
            url: "/api/order/getStockPickPage",
            method: "GET",
            params: {
              fcCode: this.outsoureListSerach.fcCode || null,
              spStatus: this.outsoureListSerach.spStatus || null,
              operaType: this.outsoureListSerach.operaType || null,
              operaCode: this.outsoureListSerach.operaCode || null,
              beginTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[0] : null,
              endTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[1] : null,
              pageNum: this.outsourceList.pageNum,
              pageSize: this.outsourceList.pageSize,
            },
          })
          .then((resp) => {
            if (resp.status == 100) {
              this.outsourceList.data = resp.data.list || [];
              this.outsourceList.total = resp.data.total;
            }
          })
          .catch((error) => {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          });
    },

    // 关闭外协拣配列表窗口
    closeOutsourceListPick(){
      this.outsourceListPickShow = false;
    },

    //表格导出
    downLoadFile(type) {
      this.downloadLoading = true;
      var paramsObj = {
        operaType:"60",
        operaCode:this.outsoureListSerach.operaCode,
        spStatus:this.outsoureListSerach.spStatus,
        beginTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[0] : null,
        endTime: this.outsoureListSerach.date ? this.outsoureListSerach.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
      }
      this.$http.request({
        url: '/api/order/getStockPickDetailList',
        method: 'GET',
        params: paramsObj
      }).then((resp) => {
        resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
          message: '查询失败'
        });
      })
    },
    downLoad(list) {
      import('@/libs/Export2Excel').then(excel => {
        list.forEach(function(c) {
          if (c.operaType == '10') {
            c['operaType'] = '生产叫料'
          } else if (c.operaType == '20') {
            c['operaType'] = '部门领用'
          } else if (c.operaType == '30') {
            c['operaType'] = '采购退货'
          } else if (c.operaType == '40') {
            c['operaType'] = '调拨移库'
          } else if (c.operaType == '60') {
            c['operaType'] = '外协'
          }

          if (c.spStatus == 'CREATE') {
            c['spStatus'] = '创建'
          } else if (c.spStatus == 'EXECUTE') {
            c['spStatus'] = '发货中'
          } else if (c.spStatus == 'COMPLETE') {
            c['spStatus'] = '完成'
          } else if (c.spStatus == 'CANCEL') {
            c['spStatus'] = '取消'
          } else if (c.spStatus == 'CLOSE') {
            c['spStatus'] = '关闭'
          }

          if (c.topFlag == true) {
            c['topFlag'] = '是'
          } else {
            c['topFlag'] = '否'
          }
          if(c.scanFlag == true){
            c['scanFlag'] = "已扫描";
          }else{
            c['scanFlag'] = "未扫描";
          }
        })
        const tHeader = ['外协单号', '物料编号', '物料描述', '物料数量', '实际发货数量', '发货扫描', '推荐库位', '实际库位','规值','箱号', '创建时间',
          '操作人'
        ]
        const filterVal = ['operaCode', 'matCode', 'matName', 'matQuan', 'realPickMat', 'scanFlag', 'laCodeAdvise', 'laCodeReal','matSpecs','boxBarcode', 'createTime',
          'person'
        ]
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '外协发货单'
        })
        this.logContent = "导出"
        this.logRemarks = "stock_pick：导出外协发货单"
        this.systemLog();
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "叫料确认",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") && "",
      };
      this.$http
          .request({
            url: "api/log/insert",
            method: "POST",
            showLoading: true,
            data: objData,
          })
          .then((resp) => {
            this.logContent = "";
            this.logRemarks = "";
            if (resp.status == 100) {}
          })
          .catch((error) => {});
    },
  },
  activated(){
    // 从页面跳转传值
    // let spCode = this.$route.query.spCode
    // if (spCode) {
    //     this.mainSearch.spCode = spCode
    // } else {
    // 	this.getStockPickPage();
    // }
    // this.getWarehouse();
    this.getTime();
    this.getOutsourceListPickShow();
    this.getStockPickDetailList();
  },
};
</script>
<style>
.div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}
</style>